<template>
  <v-data-table 
    :items="cart.products" 
    :headers="headers" 
    item-key="itemkey" 
    hide-actions>
    <template 
      slot="headers" 
      slot-scope="props">
      <th class="text-xs-left pl-2 pr-0">
        {{ props.headers[0].text }}
      </th>
      <th class="text-xs-left pr-2 pl-0">
        {{ props.headers[1].text }}
      </th>
    </template>
    <template 
      slot="items" 
      slot-scope="props">
      <td class="pl-2 pr-0">
        <v-layout column>
          <span>
            {{ props.item.name }}
          </span>
          <span class="productno-text">
            {{ props.item.product_no }}
          </span>
        </v-layout>
      </td>
      <td class="pr-2 pl-0">
        <v-icon 
          v-if="props.item.qty == null || props.item.qty == 0" 
          color="warning">warning</v-icon>
        {{ props.item.qty == 0 ? null : props.item.qty }}
      </td>
    </template>
    <template 
      slot="no-data" 
      class="pa-0">
      <v-layout justify-space-around>
        <v-icon color="warning">warning</v-icon>
        <v-subheader>
          <span>Ei tuotteita</span>
        </v-subheader>
        <v-icon color="warning">warning</v-icon>
      </v-layout>
    </template>
  </v-data-table>
</template>
<script>
export default {
	props: ['cart'],
	data() {
		return {
			headers: [
				{
					text: 'Tuote',
					value: 'name',
					sortable: false
				},
				{
					text: 'Määrä',
					value: 'qty',
					sortable: false
				}
			]
		}
	}
}
</script>
<style>
.productno-text {
  color: #888;
}
</style>
